export default __webpack_public_path__ + "static/media/2_0074.f25a87ef.webp";